import { LayoutRoute } from "../../../types";

export const SELECT_TAB = "SELECT_TAB";

export interface SelectTabAction {
  type: typeof SELECT_TAB;
  payload: LayoutRoute;
  tabId: number;
}
